import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/Layout";
import PublicLayout from "@/components/PublicLayout";

// Pages
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Rules from "@/pages/Rules";
import Triggers from "@/pages/Triggers";
import Analytics from "@/pages/Analytics";
import Billing from "@/pages/Billing";
import Admin from "@/pages/Admin";
import Platforms from "@/pages/Platforms";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import Refund from "@/pages/Refund";
import ContactUs from "@/pages/ContactUs";
import AboutUs from "@/pages/AboutUs";
import DataDeletion from "./pages/DataDeletion";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />

          <Routes>
            {/* PUBLIC ROUTES */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-and-conditions" element={<Terms />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/refund-policy" element={<Refund />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/data-deletion" element={<DataDeletion />} />
            </Route>

            {/* AUTHENTICATED APP ROUTES */}
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="rules" element={<Rules />} />
              <Route path="triggers" element={<Triggers />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="platforms" element={<Platforms />} />
              <Route path="billing" element={<Billing />} />
            </Route>

            {/* ADMIN ROUTES */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Admin />} />
            </Route>

            {/* FALLBACK */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;